/**
 * Route definitions for the API credentials section (credentials list, create credential).
 * Mirrors the pattern in views/admin/dashboard-users/routes.tsx.
 *
 * When the `developerTools` flag is on, `developerToolsRedirectRoutes` replaces the list view with a
 * redirect to the Developer Tools API Keys tab, keeping the Generate Key (`create`) route reachable.
 */
import { Navigate, Outlet, RouteObject } from "react-router-dom";
import { GraphQL } from "@rpi/openapi-api";
import { routePaths, withHandle } from "../../utils/route.util";
import { ApiCredentialCreateView } from "./ApiCredentialCreateView";
import { ApiCredentialsView } from "./ApiCredentialsView";

export const createCredentialRoute: RouteObject = {
  path: "create",
  ...withHandle("api-credential-create", {
    requiredRole: [GraphQL.DashboardUserRole.CustomerAdmin, GraphQL.DashboardUserRole.User],
  }),
  element: <ApiCredentialCreateView />,
};

export const apiCredentialsRoutes: RouteObject[] = [
  {
    path: "api-credentials",
    element: <ApiCredentialsView />,
    ...withHandle("api-credentials"),
    children: [createCredentialRoute],
  },
];

export const apiCredentialsRedirectRoutes: RouteObject[] = [
  {
    path: "api-credentials",
    element: <Outlet />,
    ...withHandle("api-credentials"),
    children: [
      {
        index: true,
        element: <Navigate to={routePaths["developer-tools:api-keys"]} replace />,
        ...withHandle("api-credentials-redirect"),
      },
      {
        // The drawer itself lives under the Developer Tools API Keys tab so it opens over the
        // list; this keeps old /api-credentials/create deep links working.
        path: "create",
        element: <Navigate to={routePaths["developer-tools:api-keys:create"]} replace />,
        ...withHandle("api-credential-create-redirect"),
      },
    ],
  },
];
